// ======================================================================
// File Name       : service
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/service';

export function receiveServiceNotificationList(resdata) {
  return {
    type: ActionTypes.RECEIVE_SERVICE_NOTIFICATION_LIST,
    searchResult: resdata,
  };
}

export function receiveServiceNoticeDetail(resdata, userListToStore, groupRelationList, groupInfo) {
  return {
    type: ActionTypes.RECEIVE_SERVICE_NOTICE_DETAIL,
    searchResult: resdata,
    userListToStore,
    groupRelationList,
    groupInfo,
  };
}

export function initServiceNoticeDetailForEdit(
  resdata,
  userListToStore,
  groupRelationList,
  groupInfo,
) {
  return {
    type: ActionTypes.INIT_SERVICE_NOTICE_DETAIL,
    searchResult: resdata,
    userListToStore,
    groupRelationList,
    groupInfo,
  };
}

export function storeUserList(userSearchResult, groupRelationList, groupInfo) {
  return {
    type: ActionTypes.STORE_SERVICE_USER_LIST,
    userSearchResult,
    groupRelationList,
    groupInfo,
  };
}

export function addUsersToListByGroups(userListToAdd, groupRelationList, groupInfo) {
  return {
    type: ActionTypes.ADD_SERVICE_USER_TO_LIST_BY_GROUPS,
    userListToAdd,
    groupRelationList,
    groupInfo,
  };
}

export function addUsersToList(userListToAdd) {
  return {
    type: ActionTypes.ADD_SERVICE_USER_TO_LIST,
    userListToAdd,
  };
}

export function removeUserFromList(userSecernId) {
  return {
    type: ActionTypes.REMOVE_SERVICE_USER_FROM_LIST,
    userSecernId,
  };
}

export function resetEdittingUsers() {
  return {
    type: ActionTypes.RESET_EDITING_SERVICE_USERS,
  };
}

export function allUserReceived(data) {
  return {
    type: ActionTypes.ALL_USER_RECEIVED,
    data,
  };
}

export function removedAllUserByGroup() {
  return {
    type: ActionTypes.REMOVED_ALL_USER_RECEIVED,
  };
}

export function initializeVideoSpeedOptions(videoSpeedArr) {
  return {
    type: ActionTypes.INITIALIZE_VIDEO_SPEED_OPTIONS,
    videoSpeedArr,
  };
}

export function updateVideoSpeedUsage(isUsed) {
  return {
    type: ActionTypes.UPDATE_VIDEO_SPEED_USAGE,
    isUsed,
  };
}
